import { ReservationSearchFilters } from "../../Types/reservationTypes";

export const reservationValuesSearch: ReservationSearchFilters = {
	createdAt: "",
	source: "",
	offerId: "",
	applicantFirstName: "",
	applicantLastName: "",
	applicantEmail: "",
};
